import Axios from 'axios';
import { protectedResources } from '../authConfig';

/**
 * Update advance salary request for an employee.
 * Only send fields that are provided (not null/undefined).
 * @param {Object} params - { employeeId, year, month, status, remark }
 * @returns {Promise<any>} API response
 */
export const UpdateAdvanceSalaryRequest = async (params) => {
  let tokenKey;
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  const URL =
    protectedResources.apiHRMobile.baseApi +
    '/api/v1/AdvanceSalary/UpdateAdvanceSalaryRequest';
  // Remove undefined/null fields
  const body = {};
  ['employeeId', 'year', 'month', 'status', 'remark'].forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      body[key] = params[key];
    }
  });
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenKey}`,
    },
  };
  try {
    const response = await Axios.post(URL, body, config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem('obj_user_info');
      sessionStorage.removeItem('AccessToken');
      throw new Error('Unauthorized');
    }
    throw error;
  }
};
